import type { FacetKey } from '@/composables/useFacetSuggestions'
import type { AfpClass } from '@/config/deck/classes'
import type { SearchQueryParams } from 'afpnews-api'
import { eventIdsFromQuery } from '@/lib/events'
import { buildEventQuery } from '@/router/utils'

export interface DeckQueryInput {
  q?: string
  topic?: string
  lang?: string
  class?: AfpClass
  facet?: { key: FacetKey; value: string }
}

export function buildDeckQuery(input: DeckQueryInput): Record<string, string> {
  const query: Record<string, string> = {}
  if (input.q) query.q = input.q
  if (input.topic) query.topic = input.topic
  if (input.lang) query.lang = input.lang
  if (input.class) query.class = input.class
  if (input.facet) query[input.facet.key] = input.facet.value
  return query
}

// Inverse de buildColumnFromDeckQuery pour ce que les clés de /new savent exprimer : fournisseurs et genres
// exclus n'y figurent pas, ils reprennent les valeurs par défaut d'une colonne
export function deckQueryFromSearchParams(
  params: SearchQueryParams
): Record<string, string> {
  const single = (value: unknown) =>
    typeof value === 'string' && value ? value : undefined
  // Une requête faite uniquement d'événements (colonne événement) repasse par ?event=
  const eventIds = eventIdsFromQuery(params.query)
  const eventOnly =
    eventIds.length > 0 && params.query === buildEventQuery(eventIds)
  const query = buildDeckQuery({
    q: eventOnly ? undefined : single(params.query),
    topic: single(params.topic),
    lang:
      params.langs && !params.langs.length ? 'all' : params.langs?.join(','),
    class: single(params.class) as AfpClass | undefined
  })
  if (eventOnly) query.event = eventIds.join(',')
  const from = single(params.dateFrom)
  const to = single(params.dateTo)
  if (from) query.from = from
  if (to) query.to = to
  return query
}
